// extracted by css-extract-rspack-plugin
export default {"wsiCard":"src-widgets-WsiCard-module__wsiCard-Rt61gF","title":"src-widgets-WsiCard-module__title-Jg3gAc"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"wsiCard\":\"src-widgets-WsiCard-module__wsiCard-Rt61gF\",\"title\":\"src-widgets-WsiCard-module__title-Jg3gAc\"}";
        // 1793732399213
        var cssReload = require("../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  